import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
}));

export default function CommonMultiSearch({
  data, label, onChange, selectedValue,
}) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Autocomplete
        fullWidth={false}
        multiple
        id="multiSelectSearchField"
        className="multiSelectSearchField"
        options={data}
        onChange={(event, newValue) => {
          onChange(newValue)
        }}
        value={selectedValue}
        label
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.text;
        }}
        renderOption={(option) => option.text}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={label} placeholder={label} />
        )}
      />
    </div>
  );
}
